import type { TcWorkspaceHeaderResponse } from 'types/type-curve-workspace-show';
import type { TypeCurveWorkspaceResponse } from 'types/type-curve-workspace';

/**
 * The server's promote blockers beyond the tasks (an archived Type Curve Area), for an
 * unpromoted workspace. A promoted workspace has nothing left to block.
 * @param workspace the active workspace, or null before it loads
 * @param header the workspace's header detail, or nothing before it loads
 */
export const workspacePromoteBlockers = (
  workspace: Pick<TypeCurveWorkspaceResponse, 'promoted'> | null,
  header:
    | Pick<TcWorkspaceHeaderResponse, 'domainPromotionBlockers'>
    | null
    | undefined
): string[] =>
  workspace && !workspace.promoted
    ? (header?.domainPromotionBlockers ?? [])
    : [];
